<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <defs>
            <clipPath id="clip-Arrow_back">
                <rect width="24" height="24"/>
            </clipPath>
        </defs>
        <g id="Arrow_back" clip-path="url(#clip-Arrow_back)">
            <rect width="24" height="24" fill="transparent"/>
            <g id="Group_13363" data-name="Group 13363">
                <path id="Path_4251" data-name="Path 4251" d="M0,0H24V24H0Z" :class="arrowFillClass" opacity="0"/>
                <path id="Path_4252" data-name="Path 4252" d="M21,11H6.83l3.58-3.59L9,6,3,12l6,6,1.41-1.41L6.83,13H21Z" :class="arrowFillClass" />
            </g>
        </g>
    </svg>

</template>

<script>
export default {
    name: "arrowBackIcon",
    props: {
        arrowFillClass: {
            type: String,
            default: 'svg-secondary-color'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/arrowBackIcon.vue